export type AdminProductScope = 'app' | 'studio' | 'platform';

export const PRODUCT_SCOPE_LABELS: Record<AdminProductScope, string> = {
  app: 'APP',
  studio: 'STUDIO',
  platform: 'PLATFORM',
};

export function productScopeFromPath(pathname: string): AdminProductScope | null {
  const segment = pathname.split('/').filter(Boolean)[0];
  if (segment === 'app' || segment === 'studio' || segment === 'platform') {
    return segment;
  }
  return null;
}

export function scopedPath(scope: AdminProductScope, subpath = ''): string {
  const normalized = subpath.startsWith('/') ? subpath.slice(1) : subpath;
  return normalized ? `/${scope}/${normalized}` : `/${scope}`;
}
